import { render, staticRenderFns } from "./ArticleDistribution.vue?vue&type=template&id=719645a0&scoped=true"
import script from "./ArticleDistribution.vue?vue&type=script&lang=js"
export * from "./ArticleDistribution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719645a0",
  null
  
)

export default component.exports